<template>
   
    <div> 
        <div class="crumbs" hidden="true"  style="margin-left:10px;">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar"></i> 权限管理
                </el-breadcrumb-item>
                <el-breadcrumb-item>菜单管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
          <el-card shadow="hover"  class="searchCard" >
                <span class="label-span">
                    <label class="label">城市名称</label> 
                    <el-input v-model.trim="query.name" placeholder="城市名称" class="handle-input mr15"></el-input>  
                </span>
                <span  class="label-span">
                    <label class="label">区域级别</label> 
                    <el-select v-model="query.level"  placeholder="区域级别" clearable class="handle-select mr15">
                        <el-option value="" label="全部"  />   
                        <el-option value="1" label="省级"  /> 
                        <el-option value="2" label="市级"  /> 
                    </el-select>
                </span>
                <span  class="label-span">
                    <label class="label">是否显示</label> 
                    <el-select v-model="query.status"  placeholder="是否显示" clearable class="handle-select mr15">
                        <el-option value="" label="全部"  />   
                        <el-option value="1" label="显示"  /> 
                        <el-option value="0" label="不显示"  /> 
                    </el-select>
                </span>
                
                <el-button type="success" icon="el-icon-search" class="mr10"   @click="handleSearch">搜索</el-button>
                <el-button type="error" icon="el-icon-refresh" class="mr10" style="margin-right:25px"   @click="refreshSearch">重置</el-button>
                <el-button  type="primary"  icon="el-icon-lx-roundadd" class="mr10"  @click="addBind" >添加菜单</el-button>  
   
               
          </el-card>
          <el-card shadow="hover"  class="containCard" >
            <el-table :data="tableData" class="table"   row-key="id" lazy :load="load" :tree-props="{children: 'children', hasChildren: 'hasChildren'}">> 
                <el-table-column prop="id" min-width="110" align="left" label="城市ID"></el-table-column> 
                <el-table-column prop="name" min-width="120"   label="菜单名称"> </el-table-column> 
                <el-table-column prop="code" min-width="110" align="left" label="行政编码"></el-table-column>
                <el-table-column prop="" min-width="80" align="left" label="城市等级">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.level==1?'success':'primary'">{{scope.row.level==1?'省级':'市级'}}</el-tag> 
                    </template>
                </el-table-column>  
                <el-table-column prop="status" width="90" align="center" label="是否显示">
                    <template slot-scope="scope" > 
                         <el-tooltip :content="scope.row.status=='1'?'显示':'不显示'" placement="top">
                            <el-switch @change="handleStatus(scope.$index, scope.row)"
                                v-model="scope.row.status"
                                active-color=""
                                inactive-color=""
                                active-value="1"
                                inactive-value="0">
                            </el-switch>
                        </el-tooltip>
                    </template>  
                </el-table-column>
                <el-table-column prop="fb1" min-width="80" align="left" label="排序ID"></el-table-column>  
                <el-table-column label="操作" min-width="145" align="center" fixed="right">
                    <template slot-scope="scope">  
                        <span class='tableOperBtn' @click="handleEdit(scope.$index, scope.row)" ><i class='el-icon-edit'></i> 编辑</span>
                        <span class='tableOperBtn' @click="handDelete(scope.$index, scope.row)" ><i class='el-icon-delete'></i> 删除</span>
                    </template>
                </el-table-column> 
            </el-table> 
          </el-card>
        
     
        <!-- 新建代理渠道弹出框 --> 
        <el-dialog :close-on-click-modal="false" title="添加菜单" :modal-append-to-body='false' :visible.sync="addPlusVisible" top="80px" width="400px">
            <el-form ref="form1" :model="form1" label-width="90px"  @submit.native.prevent="saveForm">
                <el-form-item label="城市等级" >
                    <el-radio-group v-model.trim="form1.level" >
                        <el-radio-button label="1">省级</el-radio-button> 
                        <el-radio-button label="2">市级</el-radio-button> 
                    </el-radio-group>    
                </el-form-item>    
                <el-form-item label="上级省份" v-if="form1.level==2" >
                    <el-select  v-model.trim="form1.level" style="width:100%"  placeholder="请选择上级菜单">
                        <el-option v-for="item in select.option" :key="item.id" :label="item.optVal" :value="item.optKey" />    
                    </el-select>   
                </el-form-item>   
                <el-form-item label="城市名称" >
                    <el-input  v-model.trim="form1.name"  placeholder="必填"></el-input>   
                </el-form-item>    
                <el-form-item label="行政编码" >
                    <el-input  v-model.trim="form1.code"  placeholder="必填"></el-input>   
                </el-form-item>    
                <el-form-item label="是否显示" >
                    <el-radio-group v-model.trim="form1.status" >
                        <el-radio-button label="1">是</el-radio-button> 
                        <el-radio-button label="0">否</el-radio-button> 
                    </el-radio-group>    
                </el-form-item>  
                <el-form-item label="城市排序" >
                    <el-input  v-model.trim="form1.fb1"  placeholder="数字越小，排序越靠前"></el-input>   
                    <p>数字越小，排序越靠前</p>
                </el-form-item>    
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addPlusVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveForm">{{ isSubmitting ? '提交中...' : '提 交' }}</el-button>
            </span>
        </el-dialog>
  

     
        <!-- 编辑代理渠道弹出框 --> 
        <el-dialog :close-on-click-modal="false" title="编辑菜单" :modal-append-to-body='false' :visible.sync="editPlusVisible" top="80px" width="520px">
            <el-form ref="form" :model="form3" label-width="90px">  
                <el-form-item label="城市等级" >
                    <el-radio-group v-model.trim="form3.level" >
                        <el-radio-button label="1">省级</el-radio-button> 
                        <el-radio-button label="2">市级</el-radio-button> 
                    </el-radio-group>    
                </el-form-item>    
                <el-form-item label="上级省份" v-if="form3.level==2" >
                    <el-select  v-model.trim="form3.level" style="width:100%"  placeholder="请选择上级菜单">
                        <el-option v-for="item in select.option" :key="item.id" :label="item.optVal" :value="item.optKey" />    
                    </el-select>   
                </el-form-item>   
                <el-form-item label="城市名称" >
                    <el-input  v-model.trim="form3.name"  placeholder="必填"></el-input>   
                </el-form-item>    
                <el-form-item label="行政编码" >
                    <el-input  v-model.trim="form3.code"  placeholder="必填"></el-input>   
                </el-form-item>    
                <el-form-item label="是否显示" >
                    <el-radio-group v-model.trim="form3.status" >
                        <el-radio-button label="1">是</el-radio-button> 
                        <el-radio-button label="0">否</el-radio-button> 
                    </el-radio-group>    
                </el-form-item>  
                <el-form-item label="城市排序" >
                    <el-input  v-model.trim="form3.fb1"  placeholder="数字越小，排序越靠前"></el-input>   
                    <p>数字越小，排序越靠前</p>
                </el-form-item>   
            </el-form>
            <span slot="footer" class="dialog-footer" >
                <el-button @click="editPlusVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit">确 定</el-button>
            </span>
        </el-dialog>
         
 
 

        
    </div>
</template>

<script>
import {fetchData,fetchSelect,saveForm,handDelete,changeForm,changeStatus} from '../../api/city';   
export default {

    data() {
        return {  
            isSubmitting: false, // 是否正在提交
            Timeout:'', 
            activeNames:1,
            select:{ option:'',  },
            sendSms:{
                code:'', 
                content:'发送验证码',
                type:'danger',
                disabled:false,
                color:'color:#fff',
             },
            
            query: { 
                pageIndex: 1,
                pageSize: 10, 
            },
            tableData: [],
            tableData2: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            showVisible:false,
            editPlusVisible: false,
            addVisible: false,
            addPlusVisible:false,
            detailVisible:false, 
            dirVisible:false,
            row:{},
            pageTotal: 0,
            select:{
                option:'',
            },
            form: {  
                ids:'',
                names:'',
            },
            form1: {
                status:'1', 
                gid:'1',
                subs:'0',
            },
            form2: {   },
            form3: {   },
            idx: -1,
            id: -1,
            // 获取row的key值
         
        // 要展开的行，数值的元素是row的key值
     
        };
    },
    created() {
         
    }, 
    //页面加载方法
    mounted: function () {
         
        //查询列表
        this.getData();  
        
    },

    methods: {  
        load(tree, treeNode, resolve) {  
            setTimeout(() => {
            resolve(tree.subs);  
            },200);
            
        }, 
        // 触发搜索按钮 
        handleSearch() {
            this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },

        //重置按钮
        refreshSearch(){ 
            this.$set(this.query, 'name');  
            this.$set(this.query, 'level');  
            this.$set(this.query, 'status');    
            this.handleSearch();
        }, 
     
        //触发刷新按钮
        refresh(){
            history.go(0);
            
        },

        //获取下拉框数据
        getSelect(){   
            fetchSelect(this.select).then(res => {   
                if(res.code=='200'){ 
                    this.select.option = res.data; 
                }
            });
        }, 
        showIcon(){
            this.showVisible=true;
        },

        //查询
        getData(){  
            this.tableData = [];
            fetchData(this.query).then(res => {  
                if(res.code=='200'){ 
                    this.tableData = res.data; 
                }else{
                    this.tableData = [];  
                } 
                
            });
        },
        

        // 新增渠道
        addBind() {
            this.getSelect();
            this.addPlusVisible = true; 
            
        },
        //保存新增
        saveForm() {   
            if (this.isSubmitting) return;
            this.isSubmitting = true; // 禁用按钮
            if( !this.form1.gid ){
                this.isSubmitting = false;
                this.$message.error("请选择菜单等级");
                return;
            }
            if( this.form1.gid==2 && !this.form1.pid ){
                this.isSubmitting = false;
                this.$message.error("请选择上级菜单");
                return;
            }
             
            if( !this.form1.title ){
                this.isSubmitting = false;
                this.$message.error("请填写菜单名称");
                return;
            } 
            if(  !this.form1.fb1 ){
                this.isSubmitting = false;
                this.$message.error("请填写排序");
                return;
            } 
            if(this.form1.gid==1 && !this.form1.icon ){
                this.isSubmitting = false;
                this.$message.error("请填写菜单图标");
                return; 
            }  
           
            this.loading = true; 
            this.addPlusVisible = false;  
            saveForm(this.form1).then(res => {
                this.loading = false; 
                this.isSubmitting = false;
                if(res.code=='200'){  
                    this.$message.success(res.message); 
                    this.refreshSearch();
                }else{
                    this.addPlusVisible = true;  
                    this.$message.error(res.message); 
                } 
            });
        },

        

        // 编辑操作
        handleEdit(index, row) {  
            this.getSelect();
            this.editPlusVisible = true;
            this.form3 = row;   
        },

         
        // 保存更改
        saveEdit() {  
            this.form3.mid = this.mid;
            this.form3.stationId = this.stationId;   
            changeForm(this.form3).then(res => {
                if(res.code=='200'){
                    this.editVisible = false;
                    this.editPlusVisible = false;
                    this.$message.success(res.message); 
                    this.getData();
                }else{
                    this.$message.error(res.message); 
                }
            });
        },
        // q启用、禁用--改变状态
        handleStatus(index, row) { 
            let data = {};
            data.id = row.id;
            data.status = row.status;
            data.stationId = this.stationId; 
            data.mid = this.mid; 
            var tips="开启显示";
            if(row.status==0){
                tips="关闭显示";
            } 
            changeStatus(data).then(res => {
                if(res.code=='200'){ 
                    this.$message.success(tips+'成功'); 
                    this.getData();
                }else{ 
                    this.$message.error(tips+'失败');
                } 
            }); 
        },
 
        
        //详情
        handleDetail(index, row){
            this.form2 = row; 
            if(row.channelType=='1'){
                this.detailVisible = true; 
            }
            
        },
        // 删除
        handDelete(index, row) {  
            this.form.id=row.id; 
            this.form.mid = this.mid;
            this.form.stationId = this.stationId; 
            // 二次确认删除
            this.$confirm('确定要删除该菜单吗？', '提示', {
                type: 'warning'
            }).then(() => {
                handDelete(this.form).then(res => {
                    if(res.code=='200'){ 
                        this.$message.success('删除成功');  
                        this.getData();
                    }else{
                        this.$message.error("删除失败"); 
                    } 
                });
            }) 
        },
        // 分页导航
        handlePageChange(val) { 
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
        //分页数量更改导航
        handleSizeChange(val){
            this.$set(this.query, 'pageSize', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    width:100%;
    margin-bottom: 20px;
    overflow-x:auto;
}

.handle-select {
    width: 100px;
    display: inline-block;
}

.handle-input {
    width: 150px;
    display: inline-block; 
}
.handle-del {
    float:right; 
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr15 {
    margin-right: 15px;
}
.mr10 {
    margin-right: 10px;
    margin-left:0;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
  .label{
    background: #eee;
    font-size: 14px;
    height: 32px;
    display: inline-block;
    line-height: 33px; 
    color: #555;
    width:100px;
    text-align:center;
  }
  .label-span{
      display: inline-block;
      height: 45px;
  }
</style>
<style>
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }

  .el-table thead{
      color: #666;
        font-weight: 500;
        font-size: 14px;
  }
 
</style>
